import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
import _ from "lodash";

class SKeyboard {
    #elm;

    constructor() {
        // create keyboard element
        const keyboard_elm = document.createElement("div");
        keyboard_elm.classList.add("simple-keyboard");
        keyboard_elm.style.cssText = "display: none;";
        document.body.appendChild(keyboard_elm);
        this.#elm = keyboard_elm;
    }

    static #handleShift(keyboard) {
        const currentLayout = keyboard.options.layoutName;
        const shiftToggle = currentLayout === "default" ? "shift" : "default";

        keyboard.setOptions({
            layoutName: shiftToggle,
        });
    }

    static #handleMobileShift(keyboard) {
        const currentLayout = keyboard.options.layoutName;
        const shiftToggle =
            currentLayout === "mobileDefault" ? "mobileShift" : "mobileDefault";

        keyboard.setOptions({
            layoutName: shiftToggle,
        });
    }

    static #handleMobileNumbers(keyboard) {
        const currentLayout = keyboard.options.layoutName;
        const numbersToggle =
            currentLayout !== "mobileShift" ? "mobileNumbers" : currentLayout;

        keyboard.setOptions({
            layoutName: numbersToggle,
        });
    }

    static #handleMobileSymbols(keyboard) {
        const currentLayout = keyboard.options.layoutName;
        const symbolsToggle =
            currentLayout !== "mobileSymbols" ? "mobileSymbols" : currentLayout;

        keyboard.setOptions({
            layoutName: symbolsToggle,
        });
    }

    static #handleMobileAlpha(keyboard) {
        const currentLayout = keyboard.options.layoutName;
        const symbolsToggle =
            currentLayout !== "mobileDefault" ? "mobileDefault" : currentLayout;

        keyboard.setOptions({
            layoutName: symbolsToggle,
        });
    }

    static #onKeyPress(button, keyboard) {
        if (button === "{shift}" || button === "{lock}") {
            SKeyboard.#handleShift(keyboard);
        } else if (button === "{bksp}" || button === "{backspace}") {
            document.activeElement.value = document.activeElement.value.slice(
                0,
                -1
            );
            $(document.activeElement).trigger("change");
        } else if (button === "{mshift}") {
            SKeyboard.#handleMobileShift(keyboard);
        } else if (button === "{mnumbers}") {
            SKeyboard.#handleMobileNumbers(keyboard);
        } else if (button === "{msymbols}") {
            SKeyboard.#handleMobileSymbols(keyboard);
        } else if (button === "{malpha}") {
            SKeyboard.#handleMobileAlpha(keyboard);
        } else if (
            !_.includes(
                [
                    "{bksp}",
                    "{tab}",
                    "{lock}",
                    "{enter}",
                    "{shift}",
                    "{shift}",
                    "{mshift}",
                    "{mnumbers}",
                    "{msymbols}",
                    "{malpha}",
                ],
                button
            )
        ) {
            const active_element = document.activeElement;
            active_element.value += button === "{space}" ? " " : button;
            $(document.activeElement).trigger("change");
        }
    }

    add() {
        const keyboard = new Keyboard({
            onKeyPress: (button) => SKeyboard.#onKeyPress(button, keyboard),
            layoutName:
                document.body.clientWidth > 766 ? "default" : "mobileDefault",
            layout: {
                default: [
                    "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                    "{tab} q w e r t y u i o p [ ] \\",
                    "{lock} a s d f g h j k l ; ' {enter}",
                    "{shift} z x c v b n m , . / {shift}",
                    "{space}",
                ],
                shift: [
                    "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                    "{tab} Q W E R T Y U I O P { } |",
                    '{lock} A S D F G H J K L : " {enter}',
                    "{shift} Z X C V B N M < > ? {shift}",
                    "{space}",
                ],
                mobileDefault: [
                    "q w e r t y u i o p",
                    "a s d f g h j k l",
                    "{mshift} z x c v b n m {backspace}",
                    "{mnumbers} {space} {enter}",
                ],
                mobileShift: [
                    "Q W E R T Y U I O P",
                    "A S D F G H J K L",
                    "{mshift} Z X C V B N M {backspace}",
                    "{mnumbers} {space} {enter}",
                ],
                mobileNumbers: [
                    "1 2 3 4 5 6 7 8 9 0",
                    '- / : ; ( ) $ & @ "',
                    "{msymbols} . , ? ! ' {backspace}",
                    "{malpha} {space} {enter}",
                ],
                mobileSymbols: [
                    "1 2 3 4 5 6 7 8 9 0",
                    "[ ] { } # % ^ * + =",
                    "{mnumbers} _ \\ | ~ ` {backspace}",
                    "{malpha} < {space} > {enter}",
                ],
            },
            mergeDisplay: true,
            display: {
                "{mshift}": "⇧",
                "{mnumbers}": "123",
                "{msymbols}": "#+=",
                "{malpha}": "ABC",
            },
        });
        this.#events(keyboard);

        return keyboard;
    }

    #events(keyboard) {
        const $keyboard = $(this.#elm);
        const input_elm = $("[vKeyboard]");

        const toggle_elm = $(
            '<i class="icon pi-keyboard show_keyboard"></i>'
        ).on("click", function () {
            const $this = $(this);
            const input = $this.parent().prev();
            input.addClass("keyboard_shown");
            const bottom =
                input.position().top +
                input.offset().top +
                input.outerHeight(false);
            const { left } = input.offset();

            $keyboard.css({
                top: bottom + 4,
                left,
            });
            if ($keyboard.is(":hidden")) {
                $keyboard.slideDown();
            }

            input.trigger("focus");
        });

        let in_input = input_elm.next("div.in_input");
        if (in_input.length > 0) {
            in_input.append(toggle_elm);
        } else {
            in_input = $('<div class="in_input"></div>');
            in_input.append(toggle_elm);
            input_elm.after(in_input);
        }

        input_elm.on("focusout", function () {
            $(this).removeClass("keyboard_shown");

            setTimeout(() => {
                if (!input_elm.hasClass("keyboard_shown")) {
                    $keyboard.hide();
                }
            }, 30);
        });

        $(".simple-keyboard").on("mousedown", (event) => {
            event.preventDefault();
        });

        // change keyboard layout to mobile on device width change
        $(window).on("resize", () => {
            keyboard.setOptions({
                layoutName:
                    document.body.clientWidth > 766
                        ? "default"
                        : "mobileDefault",
            });
        });
    }
}

export default SKeyboard;
export { SKeyboard };
